import { OfflineCatalogFilterOptionsMetadata } from '../../../../../../../../database/offlineDatabase/types/offlineDatabaseCatalog.types';
import { FilterOptionsMetadataAddFromParams } from './types/filterOptionsMetadata.types';

export default class FilterOptionsMetadata {
  private categoryIds = new Set<string>();
  private collectionIds = new Set<string>();
  private colorIds = new Set<string>();
  private sizeIds = new Set<string>();
  private referenceColorIds = new Set<string>();
  private classificationIds = new Set<string>();
  private deliveryWindowIds = new Set<string>();
  private sellInPriceByPriceTable = new Map<string, { min: number; max: number }>();

  private addCategoryIds(ids: string[]) {
    ids.forEach((id) => this.categoryIds.add(id));
  }

  private addCollectionIds(ids: string[]) {
    ids.forEach((id) => this.collectionIds.add(id));
  }

  private addColorIds(ids: string[]) {
    ids.forEach((id) => this.colorIds.add(id));
  }

  private addSizeIds(ids: string[]) {
    ids.forEach((id) => this.sizeIds.add(id));
  }

  private addReferenceColorIds(ids: string[]) {
    ids.forEach((id) => this.referenceColorIds.add(id));
  }

  private addClassificationIds(ids: string[]) {
    ids.forEach((id) => this.classificationIds.add(id));
  }

  private addDeliveryWindowIds(ids: string[]) {
    ids.forEach((id) => this.deliveryWindowIds.add(id));
  }

  mergeSellInPriceRange(priceTableId: string, range: { min: number; max: number }): void {
    const current = this.sellInPriceByPriceTable.get(priceTableId);
    if (!current) {
      this.sellInPriceByPriceTable.set(priceTableId, range);
    } else {
      this.sellInPriceByPriceTable.set(priceTableId, {
        min: Math.min(current.min, range.min),
        max: Math.max(current.max, range.max),
      });
    }
  }

  addFrom(filterOptions: FilterOptionsMetadataAddFromParams): void {
    this.addColorIds(filterOptions.colorIds);
    this.addCategoryIds(filterOptions.categoryIds);
    this.addCollectionIds(filterOptions.collectionIds);
    this.addSizeIds(filterOptions.sizeIds);
    this.addReferenceColorIds(filterOptions.referenceColorIds);
    this.addClassificationIds(filterOptions.classificationIds);
    this.addDeliveryWindowIds(filterOptions.deliveryWindowIds);
  }

  toOfflineCatalogFilterOptionsMetadata(): OfflineCatalogFilterOptionsMetadata {
    const sellInPriceByPriceTable: Record<string, { min: number; max: number }> = {};
    this.sellInPriceByPriceTable.forEach((value, key) => {
      sellInPriceByPriceTable[key] = value;
    });

    return {
      categoryIds: Array.from(this.categoryIds),
      collectionIds: Array.from(this.collectionIds),
      colorIds: Array.from(this.colorIds),
      sizeIds: Array.from(this.sizeIds),
      referenceColorIds: Array.from(this.referenceColorIds),
      classificationIds: Array.from(this.classificationIds),
      deliveryWindowIds: Array.from(this.deliveryWindowIds),
      sellInPriceByPriceTable,
    };
  }
}
